import { Button } from "@/components/ui/button";
import { useState, useEffect } from "react";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";

const Hero = () => {
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative h-screen flex items-center overflow-hidden pt-24">
      {/* Animated background */}
      <div className="absolute inset-0 z-0">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-black via-perisalah-darkblue to-black"></div>
        {/* Animated dots */}
        <div className="absolute inset-0 dot-pattern opacity-50"></div>
        {/* Animated particles */}
        <div className="absolute top-1/4 left-1/4 w-32 h-32 rounded-full bg-perisalah-purple/20 blur-3xl animate-float"></div>
        <div
          className="absolute bottom-1/3 right-1/3 w-40 h-40 rounded-full bg-perisalah-blue/20 blur-3xl animate-float"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute top-1/2 right-1/4 w-24 h-24 rounded-full bg-perisalah-purple/20 blur-3xl animate-float"
          style={{ animationDelay: "2s" }}
        ></div>
        {/* Grid lines */}
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              "linear-gradient(to right, rgba(108, 99, 255, 0.1) 1px, transparent 1px), linear-gradient(to bottom, rgba(108, 99, 255, 0.1) 1px, transparent 1px)",
            backgroundSize: "60px 60px",
            maskImage:
              "radial-gradient(circle at center, black, transparent 80%)",
          }}
        ></div>
      </div>

      <div
        className="container mx-auto px-4 z-10 mt-16"
        style={{ marginTop: "100px" }}
      >
        <div className="flex flex-col items-center text-center space-y-6 max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold leading-tight">
            <span className="text-gradient">Perisalah</span>
            <span className="block mt-2 text-white">
              Jadikan Rapat Anda Lebih Produktif
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto">
            Rekam, transkripsi, dan ubah percakapan rapat menjadi dokumen
            terstruktur secara otomatis. Perisalah adalah asisten AI yang
            membuat notulensi rapat menjadi lebih mudah.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 pt-6">
            <Button
              className="bg-perisalah-purple hover:bg-perisalah-darkerpurple text-white px-8 py-6 text-lg"
              onClick={() =>
                (window.location.href = "https://app.perisalah.ai")
              }
            >
              Mulai Gratis
            </Button>
          </div>
          <div className="w-full max-w-2xl mx-auto mt-12 glass rounded-lg p-2">
            <div className="w-full h-[300px] md:h-[400px] bg-black/60 rounded overflow-hidden">
              <video
                className="w-full h-full object-cover"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src="/demo.webm" type="video/webm" />
              </video>
            </div>
          </div>
        </div>
      </div>
      {showSignupModal && (
        <SignupModal onClose={() => setShowSignupModal(false)} />
      )}
    </section>
  );
};

export default Hero;
